<template>
  <div class="notification-container">
    <div class="notification-header">
      <div class="flex flex-row gap-1">
        <div class="icon">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="17"
              height="17"
              fill="white"
              fill-opacity="0.01"
              style="mix-blend-mode: multiply"
            />
            <path
              d="M15.6878 3.26719C15.6071 3.22056 15.5154 3.19601 15.4222 3.19601C15.3289 3.19601 15.2373 3.22056 15.1566 3.26719L10.625 5.51438V3.71875C10.6247 3.62819 10.6013 3.53921 10.557 3.46024C10.5126 3.38128 10.4488 3.31497 10.3717 3.26759C10.2945 3.22022 10.2065 3.19336 10.116 3.18957C10.0255 3.18578 9.93556 3.20519 9.85469 3.24594L5.3125 5.51438V1.59375C5.3125 1.45285 5.25653 1.31773 5.1569 1.2181C5.05727 1.11847 4.92215 1.0625 4.78125 1.0625H1.59375C1.45285 1.0625 1.31773 1.11847 1.2181 1.2181C1.11847 1.31773 1.0625 1.45285 1.0625 1.59375V14.875H15.9375V3.71875C15.9377 3.62847 15.9149 3.53963 15.8712 3.46062C15.8275 3.38161 15.7644 3.31504 15.6878 3.26719ZM11.6875 13.8125H9.5625V10.0938H11.6875V13.8125ZM14.875 13.8125H12.75V9.5625C12.75 9.4216 12.694 9.28648 12.5944 9.18685C12.4948 9.08722 12.3596 9.03125 12.2188 9.03125H9.03125C8.89035 9.03125 8.75523 9.08722 8.6556 9.18685C8.55597 9.28648 8.5 9.4216 8.5 9.5625V13.8125H2.125V2.125H4.25V7.23562L9.5625 4.57938V7.23562L14.875 4.57938V13.8125Z"
              fill="#161616"
            />
          </svg>
        </div>
        <div>
          <strong>Inventory notifications</strong>
        </div>
      </div>
      <div class="flex flex-row">
        <div>
          <p>
            Add stock threshold limit and get notified when your item runs low.
          </p>
        </div>
        <div>
          <button @click="showModel">SETUP</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModel: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped>
.notification-container {
  display: flex;
  border: black 1px solid;
  border-radius: 10px;
  padding: 10px;
  flex-direction: column;
}

.notification-header {
  display: flex;
  margin-left: 10px;
  flex-direction: column;
  gap: 10px;

  strong {
    font-size: 12px;
  }

  .icon {
    padding: 5px;
  }

  p {
    font-size: 12px;
    margin-left: 10px;
    padding-top: 4px;
  }

  button {
    text-transform: uppercase;
    border-radius: 40px;
    border: 1px solid #24292c;
    background: #dfdad2;
    height: 25px;
    margin-left: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #24292c;
    padding: 0 1rem;
    font-size: 0.813rem;
  }
}
</style>
